// Golf 3 (0034_kaart_agenda): English texts for place search, travel time and calendar feeds.
export const appPlacesEn = {
    placeholder: 'Type a place, like the swimming pool',
    hintSearch: 'Type at least 3 letters to get suggestions from Google Maps.',
    searching: 'Searching...',
    suggestions: 'Suggestions',
    noResults: 'Nothing found. You can also just type the place.',
    attribution: 'Suggestions from Google Maps',
    chosen: 'Chosen place',
    change: 'Other place',
    remove: 'Remove place',
    typedOnly: 'Text only (no place on the map)',
    notConfigured: 'Search via Google Maps is not set up on this server yet. Just type the place.',
    unavailable: 'Google Maps is not answering right now. Just type the place, or try again soon.',
    tooMany: 'A few too many searches. Try again in {minutes} minutes.',
    saveFailed: 'The place was not saved (the event was). Try again soon.',
    travelTitle: 'Travel time',
    travelAuto: '{minutes} min {mode}',
    travelAutoHint: 'Worked out from your home area. If you pick a travel time yourself, that one counts.',
    travelPending: 'Worked out when you save.',
    travelStatus: {
        no_origin: 'Choose your family location first, then the app works out the travel time.',
        no_route: 'Google Maps knows no route to this place.',
        not_configured: 'Working out travel time is not set up on this server yet.',
        unavailable: 'The travel time did not work just now. We try again the next time you save.',
        module_off: 'Travel time is off (Settings · Modules).',
    },
    modeTitle: 'How do you go?',
    modeUsual: 'As usual',
    modes: { drive: 'Car', bicycle: 'Bike', walk: 'Walk' },
    modeWith: { drive: 'by car', bicycle: 'by bike', walk: 'walking' },
    autoOption: 'Automatic ({minutes} min)',
    // fix/afspraakformulier: schakelaar bij "Waar" (onthouden op dit apparaat, per gebruiker).
    google: 'Search with Google Maps',
    googleOn: 'On: suggestions through our server (Google Maps).',
    googleOff: 'Off: you type the place yourself. Nothing goes to Google.',
    moduleOff: 'Place search is off (Settings · Modules). Just type the place.',
};
export const appTravelEn = {
    title: 'Travel time and places',
    intro: 'Pick a place from the suggestions under "Where" and the app works out how long the trip takes. The tablet then tells you in time when to leave.',
    modeTitle: 'How we usually travel',
    modeHint: 'You can pick something else per event.',
    saved: 'Saved',
    originMissing: 'Your location is still missing. Without a starting point, no travel time.',
    originLink: 'Choose location',
    googleOff: 'Google Maps is not set up on this server yet: suggestions and travel time do not work. Typing under "Where" always works.',
    privacyTitle: 'What goes to Google?',
    privacyBody: 'Only what you type under "Where", a rough area around your town (about 5 km) and, for the travel time, the starting point to about a kilometre. Never names, e-mail addresses or who is going. Google calculates for us; the tablet and your browser never talk to Google.',
    settingsBody: 'Car, bike or walking; what goes to Google',
};
export const appFeedsEn = {
    title: 'Calendar sync',
    settingsBody: 'Your events also in Google, Outlook or on the iPhone',
    intro: 'Put your events in Google Calendar, Outlook or on your iPhone as well. The board stays the place where you plan: changes made there do not come back.',
    oneWay: 'One way',
    inbound: 'The other way round, bringing in a school or sports calendar? That is under Calendars.',
    inboundLink: 'Go to Calendars',
    forWho: 'For',
    lastFetchedNever: 'never',
    settingsLabel: 'Settings of this link',
    newTitle: 'New link',
    whose: 'Which events?',
    whole: 'The whole family',
    memberOnly: 'Only {name}',
    busyOnly: 'Show "busy" only',
    busyOnlyHint: 'Others see that something is on, not what. Handy for a work calendar.',
    faith: 'Also events for our faith (such as Prayer or Mosque class)',
    faithHint: 'Off by default: Google, Microsoft or Apple would read along.',
    create: 'Make link',
    creating: 'One moment...',
    created: 'Your link is ready',
    copy: 'Copy link',
    copied: 'Copied',
    copyFailed: 'Copying did not work. Select the link and copy it yourself.',
    openApple: 'Open in Calendar (iPhone, Mac)',
    linkOnce: 'Paste the link into your calendar app now. We do not keep it readable: later you simply make a new one.',
    linkLabel: 'Your link',
    listTitle: 'Your links',
    empty: 'No links yet. Make one above.',
    forWhole: 'Whole family',
    forMember: '{name}',
    badgeBusy: 'Busy only',
    badgeFaith: 'With faith',
    lastFetched: 'Last fetched: {when}',
    neverFetched: 'Not fetched by a calendar app yet',
    hiddenLink: 'You only see the link itself when you make it.',
    renew: 'New link',
    renewTitle: 'Make a new link?',
    renewBody: 'The old link stops working. Paste the new link into your calendar app again.',
    renewConfirm: 'Make new link',
    revoke: 'Revoke',
    revokeTitle: 'Revoke link?',
    revokeBody: 'This link stops working right away. The events disappear from the other calendar at its next refresh.',
    revokeConfirm: 'Revoke',
    revoked: 'Link revoked',
    cancel: 'Cancel',
    tooMany: 'At most 20 links per family. Revoke an old link first.',
    howTitle: 'How to add it',
    google: {
        title: 'Google Calendar',
        steps: [
            'Open Google Calendar on a computer (calendar.google.com).',
            'On the left, next to "Other calendars", click the plus.',
            'Choose "From URL".',
            'Paste the link and click "Add calendar".',
        ],
    },
    outlook: {
        title: 'Outlook and Microsoft 365',
        steps: [
            'Open Outlook on the web (outlook.office.com or outlook.live.com).',
            'Go to Calendar and choose "Add calendar".',
            'Choose "Subscribe from web".',
            'Paste the link, name the calendar and click "Import".',
        ],
    },
    apple: {
        title: 'iPhone and iCloud',
        steps: [
            'Open Settings on your iPhone.',
            'Tap Apps, then Calendar, then Calendar Accounts, then "Add Account". (On an older iPhone: Calendar, then Accounts.)',
            'Tap "Other", then "Add Subscribed Calendar".',
            'Paste the link and tap "Next" and "Save".',
        ],
    },
    refreshNote: 'To be honest: Google Calendar only fetches such a link every few hours, sometimes less often. Outlook and the iPhone do it more often. So a change does not show everywhere right away; on the board it does.',
    privacyNote: 'Private events never go along. Anyone with the link can read the events: do not share it further, and revoke it if it ends up somewhere.',
    icsBusy: 'Busy',
    /** Een bijzondere dag van meer dagen in de .ics. */
    icsDayOf: '{title} (day {index} of {count})',
};
//# sourceMappingURL=kaartApp.en.js.map